import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Beautyfloatingbutton from "../../components/beautyfloatingbutton";

import dummy from "./facial.webp";
import beforeafterdetan from "../images/services/detanbleach/beforeafterdetan.webp";
import backdetan from "../images/services/detanbleach/backdetan.webp";
import "./detanbleach.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const waxingServices = [
  { name: "Combo Offer", slug: "combo", desc: "Save on multiple services", image: dummy },
  { name: "Detan", slug: "detan", desc: "Remove Tan,Reveal Natural Glow", image: beforeafterdetan },
  { name: "Bleach", slug: "bleach", desc: "Brighten your skin tone", image: backdetan },
 
];

const Waxing = () => {
  const navigate = useNavigate();

  return (
    <div className="waxing-page-bg">
      <Header />
      <Navbar />

      {/* Hero */}
      <section className="bg-light py-4">
        <div className="container text-center">
          <h2 className="fw-bold">Detan & Bleach</h2>
          <p className="text-muted mb-0">
            Remove Tan, Brighten Skin — At Your Doorstep
          </p>
        </div>
      </section>

      {/* Waxing Cards */}
      <section className="container my-4">
        <h5 className="fw-bold mb-3">Detan & Bleach Services</h5>

        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
          {waxingServices.map((item, idx) => (
            <div key={idx} className="col">
              <div
                className="card h-100 border-0 shadow-sm waxing-card"
                onClick={() => navigate(`/category/detanbleach/${item.slug}`)}
              >
                <img
                  src={item.image}
                  className="card-img-top"
                  alt={item.name}
                />

                <div className="card-body text-center">
                  <h6 className="fw-bold mb-1">{item.name}</h6>
                  <p className="text-muted small mb-0">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      

      <Footer />
      <Beautyfloatingbutton />
      
            {/* CTA Section */}
    </div>
  );
};

export default Waxing;
